/* eslint-disable indent */
import React from "react";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import Image from "next/image";
import { ChevronDown, ChevronUp } from "components/atoms/Icon";
import { DnD5eNPCDTO } from "types";
import * as Styled from "./NPCStats.styled";
interface NpcStatsProps {
  stats: DnD5eNPCDTO;
}
const NpcStats: React.FC<NpcStatsProps> = ({
  stats
}) => {
  return <Styled.Container data-sentry-element="unknown" data-sentry-component="NpcStats" data-sentry-source-file="index.tsx">
            <Styled.DisclosureContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                {/* General Info */}
                <Disclosure data-sentry-element="Disclosure" data-sentry-source-file="index.tsx">
                    {({
          open
        }) => <>
                            <DisclosureButton className="disclosure-button">
                                General Info
                                <Styled.Icon>
                                    <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                </Styled.Icon>
                            </DisclosureButton>
                            <DisclosurePanel className="disclosure-panel">
                                {/* General Info Fields */}
                                {stats.name && <Styled.StatItem>
                                        <Styled.StatLabel>
                                            Name:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {stats.name}
                                        </Styled.StatValue>
                                    </Styled.StatItem>}
                                {stats.npcClass && <Styled.StatItem>
                                        <Styled.StatLabel>
                                            NPC Class:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {stats.npcClass}
                                        </Styled.StatValue>
                                    </Styled.StatItem>}
                                {stats.level !== undefined && <Styled.StatItem>
                                        <Styled.StatLabel>
                                            Level:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {stats.level}
                                        </Styled.StatValue>
                                    </Styled.StatItem>}
                                {/* Add other general info fields here */}
                            </DisclosurePanel>
                        </>}
                </Disclosure>

                {/* Attributes */}
                {stats.attributes && stats.attributes.length > 0 && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Attributes
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    <Styled.GridContainer>
                                        {stats.attributes.map((attr, index) => <Styled.StatItem key={index}>
                                                <Styled.StatLabel>
                                                    {attr.name}:
                                                </Styled.StatLabel>
                                                <Styled.StatValue>
                                                    {attr.value} (
                                                    {attr.modifier})
                                                </Styled.StatValue>
                                            </Styled.StatItem>)}
                                    </Styled.GridContainer>
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.skills && stats.skills.length > 0 && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Skills
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    <Styled.GridContainer>
                                        {stats.skills.map(skill => <Styled.StatItem key={skill.name}>
                                                <Styled.StatLabel>
                                                    {skill.name}:
                                                </Styled.StatLabel>
                                                <Styled.StatValue>
                                                    {skill.bonus}
                                                </Styled.StatValue>
                                            </Styled.StatItem>)}
                                    </Styled.GridContainer>
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {/* Personality Traits */}
                {stats.personalityTraits && stats.personalityTraits.length > 0 && <Disclosure>
                            {({
          open
        }) => <>
                                    <DisclosureButton className="disclosure-button">
                                        Personality Traits
                                        <Styled.Icon>
                                            <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                        </Styled.Icon>
                                    </DisclosureButton>
                                    <DisclosurePanel className="disclosure-panel">
                                        {stats.personalityTraits.map((trait, index) => <Styled.StatItem key={index}>
                                                    <Styled.StatLabel>
                                                        Trait:
                                                    </Styled.StatLabel>
                                                    <Styled.StatValue>
                                                        {trait}
                                                    </Styled.StatValue>
                                                </Styled.StatItem>)}
                                    </DisclosurePanel>
                                </>}
                        </Disclosure>}

                {/* Continue for other sections like Goals, Flaws, Secrets, etc. */}
                {stats.goal && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Goals
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    <Styled.StatItem>
                                        <Styled.StatLabel>
                                            Goal:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {stats.goal}
                                        </Styled.StatValue>
                                    </Styled.StatItem>
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.flaws && stats.flaws.length > 0 && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Flaws
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    {stats.flaws.map((flaw, index) => <Styled.StatItem key={index}>
                                            <Styled.StatLabel>
                                                Flaw:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {flaw}
                                            </Styled.StatValue>
                                        </Styled.StatItem>)}
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.majorSecret || stats.minorSecrets ? <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Secrets
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    {stats.majorSecret && <Styled.StatItem>
                                            <Styled.StatLabel>
                                                Major Secret:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {stats.majorSecret}
                                            </Styled.StatValue>
                                        </Styled.StatItem>}
                                    {stats.minorSecrets && <Styled.StatItem>
                                            <Styled.StatLabel>
                                                Minor Secret:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {stats.minorSecrets}
                                            </Styled.StatValue>
                                        </Styled.StatItem>}
                                </DisclosurePanel>
                            </>}
                    </Disclosure> : null}

                {stats.fears && stats.fears.length > 0 && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Fears
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    {stats.fears.map((fear, index) => <Styled.StatItem key={index}>
                                            <Styled.StatLabel>
                                                Fear:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {fear}
                                            </Styled.StatValue>
                                        </Styled.StatItem>)}
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.wantsNeeds && stats.wantsNeeds.length > 0 && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Wants & Needs
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    {stats.wantsNeeds.map((wantOrNeed, index) => <Styled.StatItem key={index}>
                                                <Styled.StatLabel>
                                                    Want/Need:
                                                </Styled.StatLabel>
                                                <Styled.StatValue>
                                                    {wantOrNeed}
                                                </Styled.StatValue>
                                            </Styled.StatItem>)}
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.services && stats.services.length > 0 && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Services
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    {stats.services.map((service, index) => <Styled.StatItem key={index}>
                                            <Styled.StatLabel>
                                                Service:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {service}
                                            </Styled.StatValue>
                                        </Styled.StatItem>)}
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.rewards && stats.rewards.length > 0 && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Rewards
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    {stats.rewards.map((reward, index) => <Styled.StatItem key={index}>
                                            <Styled.StatLabel>
                                                Reward:
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {reward}
                                            </Styled.StatValue>
                                        </Styled.StatItem>)}
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.dialoguePatterns && stats.dialoguePatterns.length > 0 && <Disclosure>
                            {({
          open
        }) => <>
                                    <DisclosureButton className="disclosure-button">
                                        Dialogue Patterns
                                        <Styled.Icon>
                                            <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                        </Styled.Icon>
                                    </DisclosureButton>
                                    <DisclosurePanel className="disclosure-panel">
                                        {stats.dialoguePatterns.map((pattern, index) => <Styled.StatItem key={index}>
                                                    <Styled.StatLabel>
                                                        Pattern:
                                                    </Styled.StatLabel>
                                                    <Styled.StatValue>
                                                        {pattern}
                                                    </Styled.StatValue>
                                                </Styled.StatItem>)}
                                    </DisclosurePanel>
                                </>}
                        </Disclosure>}

                {stats.interactionStrategy && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Interaction Strategy
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    <Styled.StatItem>
                                        <Styled.StatLabel>
                                            Strategy:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {stats.interactionStrategy}
                                        </Styled.StatValue>
                                    </Styled.StatItem>
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.combatStrategy && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Combat Strategy
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    <Styled.StatItem>
                                        <Styled.StatLabel>
                                            Strategy:
                                        </Styled.StatLabel>
                                        <Styled.StatValue>
                                            {stats.combatStrategy}
                                        </Styled.StatValue>
                                    </Styled.StatItem>
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}

                {stats.equipment && stats.equipment.length > 0 && <Disclosure>
                        {({
          open
        }) => <>
                                <DisclosureButton className="disclosure-button">
                                    Equipment
                                    <Styled.Icon>
                                        <Image height={24} width={24} src={open ? ChevronUp : ChevronDown} alt="Toggle Accordion" />
                                    </Styled.Icon>
                                </DisclosureButton>
                                <DisclosurePanel className="disclosure-panel">
                                    {stats.equipment.map(item => <Styled.StatItem key={item.name}>
                                            <Styled.StatLabel>
                                                {item.name} ({item.type}
                                                ):
                                            </Styled.StatLabel>
                                            <Styled.StatValue>
                                                {item.description} (Value:{" "}
                                                {item.value})
                                            </Styled.StatValue>
                                        </Styled.StatItem>)}
                                </DisclosurePanel>
                            </>}
                    </Disclosure>}
            </Styled.DisclosureContainer>
        </Styled.Container>;
};
export default NpcStats;